var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var TimeTrackerService = /** @class */ (function (_super) {
            __extends(TimeTrackerService, _super);
            function TimeTrackerService(injectedBreeze, $q) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$q = $q;
                return _this;
            }
            TimeTrackerService.prototype.createTimePeriod = function (timeTracker) {
                var timePeriod = this.createNewEntity("TimePeriod");
                timePeriod.timeTracker_id = timeTracker.id;
                return timePeriod;
            };
            TimeTrackerService.prototype.createTimeTrackerContainer = function (processConfigId) {
                var timeTrackerContainer = this
                    .createNewEntity("TimeTrackerContainer");
                timeTrackerContainer.processConfiguration_id = processConfigId;
                timeTrackerContainer.isIndexed = false;
                return timeTrackerContainer;
            };
            TimeTrackerService.prototype.createTimeTracker = function () {
                var timeTracker = this.createNewEntity("TimeTracker");
                timeTracker.uniqueIdentifier = services.UtilityService.generateGuidComb();
                timeTracker.timeType = 3 /* Days */;
                timeTracker.useBusinessHours = false;
                timeTracker.sortOrder = 0;
                return timeTracker;
            };
            TimeTrackerService.prototype.getTimeTrackerContainersByProcess = function (processConfigId) {
                var query = this.breezeModule.EntityQuery
                    .from("TimeTrackerContainers")
                    .where('processConfiguration_id', '==', processConfigId)
                    .expand('myTimeTracker.myTimePeriods, myTimeTracker.myClockStates')
                    .orderBy("myTimeTracker.name");
                return (this.executeQuery(query));
            };
            TimeTrackerService.prototype.getTimeTracker = function (id) {
                return this.fetchById(id, "TimeTracker");
            };
            TimeTrackerService.prototype.getTimeTrackerStringValue = function (json) {
                // TODO: Need to pull configured timezone into this somehow 
                var timeTrackerObj = JSON.parse(json);
                if (timeTrackerObj.ClockStatus === 1 /* Running */) {
                    var currentDate = new Date();
                    var milleseconds = Math.floor(currentDate - new Date(timeTrackerObj.DateTimeClockValueLastChanged));
                    var seconds = Math.floor(milleseconds / 1000);
                    var minutes = Math.floor(seconds / 60);
                    var hours = Math.floor(minutes / 60);
                    var days = Math.floor(hours / 24);
                    if (timeTrackerObj.TimeType === 3 /* Days */) {
                        return timeTrackerObj.TimeElapsedLastCalculated + days;
                    }
                    else if (timeTrackerObj.TimeType === 2 /* Hours */) {
                        // TODO: When we implement minutes figure this out
                        return timeTrackerObj.TimeElapsedLastCalculated + hours;
                    }
                    else if (timeTrackerObj.TimeType === 1 /* Minutes */) {
                        // TODO: When we implement minutes figure this out
                        return timeTrackerObj.TimeElapsedLastCalculated + minutes;
                    }
                }
                return timeTrackerObj.TimeElapsedLastCalculated;
            };
            TimeTrackerService.prototype.createClockState = function () {
                return (this.createNewEntity("ClockState"));
            };
            return TimeTrackerService;
        }(services.DataService));
        services.TimeTrackerService = TimeTrackerService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('TimeTrackerService', ['breeze', '$q']);
